/**
 * Enums, labels and the next-step shapes of the tasks module (Task-Queue 01–05, Queue 03–07,
 * Kontaktakte E5) shared by the SPA's filters, dialogs and editors. The server sends the labels of
 * its rows (`typeLabel`, `cta`, …) — these constants exist for controls that offer a choice before a
 * row exists (queue filter, task editor, next-step dialog). German strings verbatim from the screens.
 */
export const taskTypes = [
    'call',
    'email',
    'whatsapp',
    'appointment_outcome',
    'document',
    'approval',
    'review',
    'ticket',
    'manual',
    'follow_up',
    'chase',
    'invoice',
    'review_documents',
    'new_financing',
    'chase_offers',
    'submit_contract',
    'follow_on_financing',
    'review_self_disclosure',
    'self_disclosure_changed',
    'record_signature',
    'offer_expiring',
];
/** The „Art" eyebrow of a task row per type. */
export const taskTypeLabels = {
    call: 'Anruf',
    email: 'E-Mail',
    whatsapp: 'WhatsApp',
    appointment_outcome: 'Termin-Ergebnis',
    document: 'Dokument',
    approval: 'Freigabe',
    review: 'Prüfung',
    ticket: 'Ticket',
    manual: 'Manuell',
    follow_up: 'Follow-up',
    chase: 'Nachfassen',
    invoice: 'Rechnung',
    review_documents: 'Unterlagen',
    new_financing: 'Neue Finanzierung',
    chase_offers: 'Bank',
    submit_contract: 'Unterschrift',
    follow_on_financing: 'Anschlussfinanzierung',
    review_self_disclosure: 'Selbstauskunft',
    self_disclosure_changed: 'Selbstauskunft',
    record_signature: 'Unterschrift',
    offer_expiring: 'Bank',
};
/** Types a user may pick in the task editor (Kontaktakte E5 chips plus „Manuell" and „Follow-up"). */
export const editableTaskTypes = [
    'manual',
    'call',
    'email',
    'whatsapp',
    'document',
    'review',
    'follow_up',
];
export const taskPriorities = ['a', 'b', 'c', 'd'];
/** Priority chips of the editor (E5): „A · Sofort", „B · Diese Woche", „C · Terminiert", „D · Wenn Zeit". */
export const taskPriorityLabels = {
    a: 'A · Sofort',
    b: 'B · Diese Woche',
    c: 'C · Terminiert',
    d: 'D · Wenn Zeit',
};
/** Skip reasons of the queue dialog (Queue 03/04). */
export const skipReasons = [
    'customer_unreachable',
    'waiting_for_reply',
    'needs_more_time',
    'not_mine',
    'other',
];
export const skipReasonLabels = {
    customer_unreachable: 'Kunde nicht erreichbar',
    waiting_for_reply: 'Warte auf Rückmeldung',
    needs_more_time: 'Braucht mehr Zeit',
    not_mine: 'Gehört nicht zu mir',
    other: 'Sonstiges',
};
export const lifecycleEndTransitions = ['no_interest', 'disqualified', 'dnc'];
/** Sub-choice of „Lifecycle beenden" (Queue 07): „Kein Interesse, Disqualifiziert oder DNC". */
export const lifecycleEndLabels = {
    no_interest: 'Kein Interesse',
    disqualified: 'Disqualifiziert',
    dnc: 'DNC',
};
//# sourceMappingURL=tasks.js.map